var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content_block"},[_vm._t("title",function(){return [(_vm.title)?_c('content-title',{domProps:{"innerHTML":_vm._s(_vm.title)}},[_vm._v(_vm._s(_vm.title))]):_vm._e()]}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }